/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BookingParams } from '../../models/booking-params';
import { BookingResponse } from '../../models/booking-response';

export interface Booking$Params {
      body: BookingParams
}

export function booking(http: HttpClient, rootUrl: string, params: Booking$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingResponse>> {
  const rb = new RequestBuilder(rootUrl, booking.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BookingResponse>;
    })
  );
}

booking.PATH = '/booking';
